import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NotificationBar from "@components/NotificationBar/index";
import "../uploaded-details.scss";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
	submitVendorCheckpointTasks,
	vendorCopySubmitCheckpointLocation,
	vendorDeleteCheckpointLocationCommnets,
	vendorDeleteCheckpointLocationFile,
	vendorGetCheckpointInfoBySpecificLocation,
	vendorGetCheckpointLocationDashboardInfo,
} from "@services/checkpoint.service";
import qs from "query-string";
import moment, { monthsShort } from "moment";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import Header from "@components/common/Header";
import {
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Modal,
	ModalBody,
} from "reactstrap";
import CommentsModal from "../Modal/comments";
import { useParams } from "react-router-dom";
import DeleteModal from "../../../../_common/deleteModal";
import { toast } from "react-toastify";
import UploadModal from "../Modal/upload";
import InputField from "../../../../_common/InputRuleFeild";
import { formatText } from "../../../../_common/text-helper";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { monthsString } from "@_common/month";
interface ICopyDocumentsProps {}

export const CopyDocuments: React.FunctionComponent<ICopyDocumentsProps> = (
	props
) => {
	let navigate = useNavigate();
	let mainParams = useParams();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [isLoading, setIsLoading] = useState(false);
	const [locations, setLocations] = useState([]);
	const [releaseCycleIds, setReleaseCycleIds] = useState<any[]>([]);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0) {
			getData();
			// getDashboardInfo();
			setDate(new Date());
		}
	}, []);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0) {
			getData();
			// getDashboardInfo();
			if (params.search_text) {
				setSearchInput(params.search_text);
				setShowSearchTextbox(true);
			}
			if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}
			if (params.limit) {
				setLimit(parseInt(params.limit));
			}
			if (params.date) {
				setDate(new Date(params.date));
			} else {
				setDate(new Date());
			}
		}
	}, [window.location.href]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const [dashboardInfo, setDashboardInfo] = useState({});
	const [dashboardLoading, setDashboardLoading] = useState(false);
	const getDashboardInfo = async () => {
		let payload: any = {
			location_id: mainParams.id,
			month: mainParams.date ? parseInt(mainParams.date.split("-")[1]) : "",
			year: mainParams.date ? parseInt(mainParams.date.split("-")[0]) : "",
			vendor_id: "",
		};

		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		try {
			setDashboardLoading(true);
			let resp = await vendorGetCheckpointLocationDashboardInfo(payload);
			if (resp) {
				setDashboardLoading(false);
				setDashboardInfo(getValue(resp, `data`, ""));
			} else {
				setDashboardLoading(false);
			}
		} catch (error) {
			setDashboardLoading(false);
		}
	};

	const getData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();

		let payload: any = {};
		if (!getValue(params, `attach_across_months`, "")) {
			payload = {
				page_no: params.page_no ? parseInt(params.page_no) : 1,
				page_size: params.limit ? parseInt(params.limit) : 10,
				search_text: params.search_text,
				status: params.status,
				sort_by: params.sort_by,
				update_status: params.update_status,
				// location_id: mainParams.id,
				month: mainParams.date ? mainParams.date.split("-")[1] : "",
				year: mainParams.date ? mainParams.date.split("-")[0] : "",
				upload_status: "NOT_UPLOADED",
				audit_status: "NOT_SUBMITTED",
				checkpoint_id: mainParams.checkpoint_id,
				is_redirect: true,
				is_release_date: true,
			};
		} else {
			payload = {
				page_no: params.page_no ? parseInt(params.page_no) : 1,
				page_size: params.limit ? parseInt(params.limit) : 10,
				search_text: params.search_text,
				status: params.status,
				sort_by: params.sort_by,
				// update_status: params.update_status,
				// location_id: mainParams.id,
				// month: mainParams.date ? mainParams.date.split("-")[1] : "",
				// year: mainParams.date ? mainParams.date.split("-")[0] : "",
				is_release_date: true,
				upload_status: "NOT_UPLOADED",
				audit_status: "NOT_SUBMITTED",
				checkpoint_id: mainParams.checkpoint_id,
				is_redirect: true,
			};
		}

		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		setIsLoading(true);
		try {
			let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
			if (resp) {
				setIsLoading(false);
				setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
				setReleaseCycleIds(getValue(
					resp,
					'data.vendors_checkpoint[0].vendor_checkpoint_audit_cycles[0].release_date_audit_cycle.id',
					""
				  ));		  
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	const getDataRefetch = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();
		let payload: any = {};
		if (!getValue(params, `attach_across_months`, "")) {
			payload = {
				page_no: params.page_no ? parseInt(params.page_no) : 1,
				page_size: params.limit ? parseInt(params.limit) : 10,
				search_text: params.search_text,
				status: params.status,
				sort_by: params.sort_by,
				update_status: params.update_status,
				// location_id: mainParams.id,
				month: mainParams.date ? mainParams.date.split("-")[1] : "",
				year: mainParams.date ? mainParams.date.split("-")[0] : "",
				upload_status: "NOT_UPLOADED",
				audit_status: "NOT_SUBMITTED",
				checkpoint_id: mainParams.checkpoint_id,
			};
		} else {
			payload = {
				page_no: params.page_no ? parseInt(params.page_no) : 1,
				page_size: params.limit ? parseInt(params.limit) : 10,
				search_text: params.search_text,
				status: params.status,
				sort_by: params.sort_by,
				// update_status: params.update_status,
				// location_id: mainParams.id,
				// month: mainParams.date ? mainParams.date.split("-")[1] : "",
				// year: mainParams.date ? mainParams.date.split("-")[0] : "",
				is_release_date: true,
				upload_status: "NOT_UPLOADED",
				audit_status: "NOT_SUBMITTED",
				checkpoint_id: mainParams.checkpoint_id,
			};
		}

		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		// setIsLoading(true);
		try {
			let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
			if (resp) {
				setIsLoading(false);
				setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                                 Delete section                             */
	/* -------------------------------------------------------------------------- */
	const [deleteObj, setDeleteObj] = useState({
		taskId: "",
		id: "",
	});

	const [isDelete, setIsDelete] = useState(false);
	const handleDelete = () => {
		setIsDelete(!isDelete);
	};

	const handleDeleteFunction = async () => {
		try {
			let resp = await vendorDeleteCheckpointLocationFile(
				deleteObj.taskId,
				deleteObj.id
			);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				handleDelete();
				getDataRefetch();
			}
		} catch (error) {}
	};

	const handleDeleteFile = async (taskId: string, id: string) => {
		setDeleteObj({
			...deleteObj,
			taskId: taskId,
			id: id,
		});
		handleDelete();
	};

	// const handleDeleteFile = async (taskId: string, id: string) => {
	// 	try {
	// 		let resp = await vendorDeleteCheckpointLocationFile(taskId, id);
	// 		if (resp) {
	// 			toast.success('Deleted successfully');
	// 			getDataRefetch();
	// 		}
	// 	} catch (error) {}
	// };

	const [comments, setComments] = useState("");
	const [submitLoading, setSubmitLoading] = useState(false);
	const handleSubmitTask = async () => {
		try {
			if (comments) {
				setSubmitLoading(true);
				let payload = {
					ids: selectedIndex,
					audit_status: "PENDING_AUDIT",
					commentsInfo: {
						comments: comments,
						type: "SUBMISSION_COMMENT",
						audit_cycle: releaseCycleId
					},
					is_copy_document: true,
					copy_from_id: mainParams.mainId,
				};
				let resp = await submitVendorCheckpointTasks(payload);
				if (resp) {
					setSubmitLoading(false);
					toast.success("Submitted successfully");
					handleModal2();
					setComments("");
					getDataRefetch();
					setSelectedIndex([]);
				}
			} else {
				toast.error("Please add comments");
				setSubmitLoading(false);
			}
		} catch (error) {
			setSubmitLoading(false);
		}
	};

	const handleSubmit = async () => {
		try {
			let payload = {
				ids: selectedIndex,
			};
			let resp = await vendorCopySubmitCheckpointLocation(
				mainParams.mainId,
				payload
			);
			if (resp) {
				toast.success("Copied successfully");
				// handleNavigate();
				getDataRefetch();
				setSelectedIndex([]);
			}
		} catch (error) {}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(10);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			...params,
			page_no: page_no,
		};
		const queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			limit: limit,
			page_no: 1,
		};
		const queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	/* -------------------------------------------------------------------------- */
	/*                               Search section                               */
	/* -------------------------------------------------------------------------- */
	const [showSearchTextbox, setShowSearchTextbox] = useState(false);
	const [search_text, setSearchInput] = useState<any>("");

	const toggleSearch = () => {
		setShowSearchTextbox((prevState) => !prevState);
	};
	const toggleSearchClose = () => {
		setSearchInput("");
		toggleSearch();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.search_text) {
			delete params.search_text;
			let payload: any = { ...params };
			// removing null values
			Object.keys(payload).forEach((key) => {
				if (!payload[key] || payload[key] === undefined) {
					delete payload[key];
				}
			});
			let queryRequest = qs.stringify(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getData();
		}
	};

	const handleChangeSearch = async (e: any) => {
		setSearchInput(e.target.value);
		let payload: any = {
			search_text: e.target.value,
		};
		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!e.target.value) {
			getData();
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	const [isOpen, setIsOpen] = useState(false);
	const handleModal = () => {
		setIsOpen(!isOpen);
	};
	const [isOpen1, setIsOpen1] = useState(false);
	const handleModal1 = () => {
		setIsOpen1(!isOpen1);
	};

	const [isOpen2, setIsOpen2] = useState(false);
	const handleModal2 = () => {
		setIsOpen2(!isOpen2);
	};

	const [vendorInfo, setVendorInfo] = useState({});
	const handleModalComment = (obj: object) => {
		setVendorInfo(obj);
		handleModal();
	};
	const handleModalCommentCancel = () => {
		setVendorInfo({});
		handleModal();
	};

	const handleModalUpload = (obj: object) => {
		setVendorInfo(obj);
		handleModal1();
	};
	const handleModalUploadCancel = () => {
		setVendorInfo({});
		handleModal1();
	};

	const handleUpdateStatus = (update_status: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.update_status = update_status;
		Object.keys(params).forEach((key) => {
			if (!params[key] || params[key] === undefined) {
				delete params[key];
			}
		});
		let queryRequest = qs.stringify(params);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	/* -------------------------------------------------------------------------- */
	/*                               Date section                                 */
	/* -------------------------------------------------------------------------- */

	const [date, setDate] = useState<Date | null>(null);
	const handleSubmitDate = () => {
		let dates = moment(date).format("YYYY-MM-DD");
		let payload: any = {
			date: dates,
		};
		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	/* -------------------------------------------------------------------------- */
	/*                               Checkbox Section                             */
	/* -------------------------------------------------------------------------- */

	const [selectedIndex, setSelectedIndex] = useState<any>([]);
	const [releaseCycleId, setReleaseCycleId] = useState<any>([]);


	const handleChangeCheckbox = (id: String) => {
		let selected = selectedIndex.filter((item: string) => item === id);
		if (getValue(selected, `length`, 0) === 0) {
			selectedIndex.push(id);
			setSelectedIndex([...selectedIndex]);
		} else {
			let selected = selectedIndex.filter((item: string) => item !== id);
			setSelectedIndex(selected);
		}
	};

	const [all, setAll] = useState("false");
	const handleChangeAllLocations = (value: string) => {
		setAll(value);
		if (value === "true") {
			let loc = locations.map((item: object) => getValue(item, `id`, ""));
			setSelectedIndex(loc);
		} else {
			setSelectedIndex([]);
		}
	};

	const handleNavigate = () => {
		navigate(
			`/checkpoint/details/${mainParams.id}/${mainParams.date}/${
				mainParams.code
			}/${getValue(mainParams, `listenable`, false)}/${getValue(mainParams, `audit_status`, false)}/${getValue(
				mainParams,
				`score`,
				""
			  )}`
		);
	};

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());

	let enableCopy =
		getValue(selectedIndex, `length`, 0) === 1 &&
		getValue(locations, `length`, 0) > 0 &&
		locations.filter(
			(item: object) =>
				getValue(item, `id`, "") === getValue(selectedIndex, `[${0}]`, "")
		);
	const attachAcrossMonths = () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (!getValue(params, `attach_across_months`, "")) {
			let payload: any = { ...params, attach_across_months: true };
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			delete params.attach_across_months;
			let payload: any = { ...params };
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getData();
		}
	};

	let selectedCheck = locations.filter((item) => {
		if (selectedIndex.includes(getValue(item, `id`, ""))) return item;
	  });
	
	  
	let checkUpload : any =  getValue(selectedCheck, `length`, 0) > 0
  ? selectedCheck.filter(
      (item: any) =>
        !getValue(item, `is_submitted`, "") ||
        getValue(item, `upload_status`, "") === "UPLOADED"
    )
  : [];
	return (
		<>
			<Header />
			<div className="checkpoint-wrapper position-relative">
				<div className="uploaded-details-wrapper uploaded-details-wrapper--checkpoint">
					<div className="sub-header d-flex align-items-center justify-content-between">
						{/* <div className="checkpoints-timer-wrapper d-flex align-items-center">
							<img src="/images/purple-awesome.svg" className="img-fluid" />
							{dashboardLoading ? (
								<p className="mx-2">Please wait...</p>
							) : (
								<p className="mx-2">
									{getValue(dashboardInfo, `releaseInfo.days`, "")}{" "}
									{getValue(dashboardInfo, `releaseInfo.msg`, "")}
								</p>
							)}
						</div> */}
					</div>
					<div className="uploaded-details-wrapper__header-checkpoint">
						<div className="d-flex align-items-center justify-content-between">
							<div className="d-flex align-items-center py-4 cursor-pointer">
								<a onClick={() => handleNavigate()}>
									<img src="/images/close-black.svg" className="img-fluid " />
								</a>
								<p className="uploaded-details-wrapper__date px-2">
									Paste to the below Checkpoints
								</p>
							</div>
							<div className="button-wrapper d-flex align-items-center gap">
								{submitLoading ? (
									<button className="ascent-button ascent-button--primary ascent-button--checkpoint d-flex align-items-center">
										<img src="/images/white-check.svg" className="img-fluid" />
										Please wait...
									</button>
								) : (
									<button
										className="ascent-button ascent-button--primary ascent-button--checkpoint d-flex align-items-center"
										onClick={handleSubmit}
										disabled={selectedIndex.length === 0}
									>
										{selectedIndex.length === 0 ? (
											<img src="/images/save-white.svg" className="img-fluid" />
										) : (
											<img src="/images/save.svg" className="img-fluid" />
										)}
										&nbsp;&nbsp;Attach Document & Save
									</button>
								)}
								{submitLoading ? (
									<button className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center">
										<img src="/images/white-check.svg" className="img-fluid" />
										Please wait...
									</button>
								) : (
									<button
										className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
										onClick={handleModal2}
										// disabled={selectedIndex.length === 0}
										disabled={selectedIndex.length < 1}
									>
										<img src="/images/white-check.svg" className="img-fluid" />
										Attach Document & Submit
									</button>
								)}
							</div>
						</div>
						<div className="d-flex">
							<div className="uploaded-details-wrapper-form-group form-group">
								<label
									className="m-0 position-relative"
									htmlFor="header-checkbox"
								>
									<input
										type="checkbox"
										className="default-checkbox"
										id="header-checkbox"
										onChange={() => attachAcrossMonths()}
										checked={
											getValue(params, `attach_across_months`, "")
												? true
												: false
										}
									/>
									<div className="custom-checkbox">
										<img
											src="/images/uploaded-details/tick.svg"
											className="img-fluid uploaded-tick"
										/>
									</div>
								</label>
							</div>
							<p>Attach Document Across All Months</p>
						</div>
					</div>

					<div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint  d-flex">
						<div className="uploaded-details-wrapper-form-group form-group">
							<label
								className="m-0 position-relative"
								htmlFor="header-checkbox"
							>
								<input
									type="checkbox"
									className="default-checkbox"
									id="header-checkbox"
									onChange={() =>
										handleChangeAllLocations(all === "true" ? "false" : "true")
									}
									checked={
										locations.length === selectedIndex.length && all === "true"
									}
								/>
								<div className="custom-checkbox">
									<img
										src="/images/uploaded-details/tick.svg"
										className="img-fluid uploaded-tick"
									/>
								</div>
							</label>
						</div>
						<div className="uploaded-details-wrapper__rules-wrapper">
							<h6 className="uploaded-details-wrapper__header-title">
								Task ID
							</h6>
							<p className="uploaded-details-wrapper__header-text">Month</p>
						</div>
						<div className="uploaded-details-wrapper__rules-wrapper">
							{/* <h6 className="uploaded-details-wrapper__header-title">
								Legislation
							</h6>
							<p className="uploaded-details-wrapper__header-text">
								Description
							</p> */}
							<h6 className="uploaded-details-wrapper__header-title">
								Compliance Activity
							</h6>
							<p className="uploaded-details-wrapper__header-text">Location</p>
						</div>
						<div className="uploaded-details-wrapper__location-wrapper">
							<h6 className="uploaded-details-wrapper__header-title">
								Location
							</h6>
							<p className="uploaded-details-wrapper__header-text">
								Audit Status
							</p>
						</div>
						{/* <div className="uploaded-details-wrapper__frequency-wrapper">
							<h6 className="uploaded-details-wrapper__header-title">
								Actions
							</h6>
						</div> */}
					</div>

					{isLoading ? (
						<Loader />
					) : getValue(locations, `length`, 0) > 0 ? (
						locations.map((uploadDetailsObj: object, index: number) => {
							const vendorCheckpointAuditCycles = getValue(uploadDetailsObj, 'vendor_checkpoint_audit_cycles', []);
							const releaseCycleId = vendorCheckpointAuditCycles
							.find((cycle:any) => {
							  const releaseDateAuditCycle = getValue(cycle, 'release_date_audit_cycle', null);
							  return releaseDateAuditCycle && Object.keys(releaseDateAuditCycle).length > 0;
							})?.id;
			
							return (
								<div className="uploaded-details-wrapper__body-checkpoint-border uploaded-details-wrapper__header-checkpoint">
									<div
										className="uploaded-details-wrapper__body  uploaded-details-wrapper__body--checkpoint  d-flex"
										key={`details-${index}`}
									>
										{/* <div></div> */}
										<div className="uploaded-details-wrapper-form-group form-group">
											<label
												className="m-0 position-relative"
												htmlFor={`details-${index}`}
											>
												<input
													type="checkbox"
													className="default-checkbox"
													id={`details-${index}`}
													checked={selectedIndex.includes(
														getValue(uploadDetailsObj, `id`, "")
													)}
													onChange={() => {
														handleChangeCheckbox(
															getValue(uploadDetailsObj, `id`, "")
														)
															setReleaseCycleId(releaseCycleId);
														}
													}
												/>
												<div className="custom-checkbox">
													<img
														src="/images/uploaded-details/tick.svg"
														className="img-fluid uploaded-tick"
													/>
												</div>
											</label>
										</div>
										<label
											className="uploaded-details-wrapper__rules-wrapper cursor-pointer"
											htmlFor={`details-${index}`}
										>
											<h6 className="uploaded-details-wrapper__body-title">
												{getValue(uploadDetailsObj, `task_id`, "")}
											</h6>
											<p className="uploaded-details-wrapper__body-text">
												{monthsString[getValue(uploadDetailsObj, `month`, "")]},{" "}
												{getValue(uploadDetailsObj, `year`, "")}
											</p>
										</label>
										<div className="uploaded-details-wrapper__location-wrapper">
											{/* <h6 className="uploaded-details-wrapper__body-title">
												{getValue(
													uploadDetailsObj,
													`location.location_name`,
													''
												)}
											</h6>
											<p className="uploaded-details-wrapper__body-text">
												{getValue(uploadDetailsObj, `vendor.vendor_name`, '')}
											</p> */}
											<h6 className="uploaded-details-wrapper__body-title">
												{getValue(
													uploadDetailsObj,
													`checkpoint.compliance_activity`,
													""
												)}
											</h6>
											<p className="uploaded-details-wrapper__body-text">
												{getValue(
													uploadDetailsObj,
													`location.location_name`,
													""
												)}
											</p>
										</div>

										<div className="uploaded-details-wrapper__status-wrapper">
											<h6
												className={`uploaded-details-wrapper__body-title uploaded-details-wrapper__body-title--${
													// getValue(uploadDetailsObj, `upload_status`, "") ===
													// "NOT_UPLOADED"
													// 	? "red"
													// 	:
													"green"
												}`}
											>
												{formatText(
													getValue(
														uploadDetailsObj,
														`location.location_name`,
														""
													)
												)}
											</h6>
											<p className="uploaded-details-wrapper__body-text">
												{formatText(
													getValue(uploadDetailsObj, `audit_status`, "")
												)}
											</p>
										</div>
										<div className="uploaded-details-wrapper__icons-wrapper">
											{getValue(uploadDetailsObj, `upload_status`, "") ===
											"UPLOADED" ? (
												<img
													src="/images/audit-review/check-green.svg"
													className="img-fluid cursor-pointer"
													height={36}
													width={36}
												/>
											) : (
												<img
													src="/images/audit-review/check-gray.svg"
													className="img-fluid cursor-pointer"
													height={36}
													width={36}
												/>
											)}
											<img
												src="/images/audit-review/mail.svg"
												className="img-fluid cursor-pointer"
												height={36}
												width={36}
												onClick={() => handleModalComment(uploadDetailsObj)}
											/>
											<img
												src="/images/audit-review/upload.svg"
												className="img-fluid cursor-pointer"
												height={36}
												width={36}
												onClick={() => handleModalUpload(uploadDetailsObj)}
											/>
											{/* <NavLink
												to={`/checkpoint/details/history/${mainParams.id}/${mainParams.date}/${mainParams.code}/${mainParams.checkpoint_id}`}
											>
												<img
													src="/images/audit-review/timer.svg"
													className="img-fluid cursor-pointer"
													height={36}
													width={36}
												/>
											</NavLink> */}
										</div>
									</div>
									<div className="d-flex align-items-center gap mx-4">
										{getValue(uploadDetailsObj, `documents.length`, 0) > 0 &&
											getValue(uploadDetailsObj, `documents`, []).map(
												(items: object, ind: number) => {
													return (
														<div key={ind}>
															{getValue(items, `extension`, "") === ".pdf" ? (
																<div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
																	<img
																		src="/images/uploaded-details/pdf.svg"
																		className="img-fluid cursor-pointer"
																	/>
																	<p className="uploaded-details-wrapper__agreement-text text-truncate">
																		{getValue(items, `name`, "")}
																	</p>
																	<img
																		// onClick={() =>
																		// 	handleDeleteFile(
																		// 		getValue(uploadDetailsObj, `id`, ""),
																		// 		getValue(items, `id`, "")
																		// 	)
																		// }
																		src="/images/uploaded-details/close-grey.svg"
																		className="img-fluid cursor-pointer"
																	/>
																</div>
															) : (
																<div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
																	<img
																		// onClick={() =>
																		// 	handleDeleteFile(
																		// 		getValue(uploadDetailsObj, `id`, ""),
																		// 		getValue(items, `id`, "")
																		// 	)
																		// }
																		src="/images/uploaded-details/word.svg"
																		className="img-fluid cursor-pointer"
																	/>
																	<p className="uploaded-details-wrapper__agreement-text text-truncate">
																		{getValue(items, `name`, "")}
																	</p>
																	<img
																		onClick={() =>
																			handleDeleteFile(
																				getValue(uploadDetailsObj, `id`, ""),
																				getValue(items, `id`, "")
																			)
																		}
																		src="/images/uploaded-details/close-grey.svg"
																		className="img-fluid cursor-pointer"
																	/>
																</div>
															)}
														</div>
													);
												}
											)}
									</div>
								</div>
							);
						})
					) : (
						<>
							{Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
						</>
					)}
					<div className="pagination-wrapper mb-3">
						{totalCount > 10 ? (
							<PaginationPage
								totalCount={totalCount}
								limit={limit}
								pageNumber={page_no}
								handleChangePagination={handleChangePagination}
								handleChangeLimit={handleChangeLimit}
							/>
						) : (
							""
						)}
					</div>
					{isOpen && (
						<CommentsModal
							{...props}
							isOpen={isOpen}
							handleModal={handleModalCommentCancel}
							vendorInfo={vendorInfo}
							edit={true}
						/>
					)}
					{isOpen1 && (
						<UploadModal
							{...props}
							isOpen={isOpen1}
							handleModal={handleModalUploadCancel}
							vendorInfo={vendorInfo}
							getData={getDataRefetch}
							mainParams={mainParams}
							getDashboardInfo={getDashboardInfo}
							handleModal2={handleModal2}
							selectedIndex={selectedIndex}
							checkUpload={checkUpload}
							handleSubmitTask={handleSubmitTask}
							releaseCycleIds={releaseCycleIds}
						/>
					)}
					{isOpen2 && (
						<Modal
							isOpen={isOpen2}
							toggle={() => handleModal2()}
							centered
							size="lg"
						>
							<div className="d-flex justify-content-between m-3">
								<div>
									<h3>Add Comments</h3>
								</div>
								<div>
									<img
										src="/images/close-black.svg"
										className="img-fluid cursor-pointer"
										onClick={handleModal2}
									/>
								</div>
							</div>
							<ModalBody>
								<div className="m-4">
									<InputField
										inputType="TEXTAREA"
										value={comments}
										onChange={(e: any) => setComments(e.target.value)}
										rows="10"
										placeholder="Add Comment"
									/>
								</div>
							</ModalBody>
							<div className="d-flex justify-content-end m-3">
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
									onClick={() => handleModal2()}
								>
									Close
								</button>
								{submitLoading ? (
									<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
										Please wait...
									</button>
								) : (
									<button
										className="ascent-button ascent-button--header-buttons ascent-button--secondary"
										onClick={handleSubmitTask}
									>
										Submit
									</button>
								)}
							</div>
						</Modal>
					)}
				</div>
				{/* <div className="w-100">
					{locations.length > 0 && (
						<img src="/images/footer.svg" className="img-fluid" />
					)}
				</div> */}
			</div>
			<DeleteModal
				isOpen={isDelete}
				handleModal={handleDelete}
				handleSubmit={handleDeleteFunction}
				deleteValue={""}
			/>
		</>
	);
};
